import React, { useState, FormEvent } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { authService } from '../api';
import AuthHeader from '../components/Header/AuthHeader';
import Button from '../components/Button';

const SifremiUnuttum: React.FC = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string>('');
  const [showSuccessModal, setShowSuccessModal] = useState<boolean>(false);

  const handleSubmit = async (e: FormEvent<HTMLFormElement>): Promise<void> => {
    e.preventDefault();
    setError('');
    const trimmedEmail = email.trim();
    if (!trimmedEmail) return;

    setLoading(true);
    try {
      const result = await authService.forgotPassword({ email: trimmedEmail });
      if (result.isSuccess) {
        setShowSuccessModal(true);
      } else {
        setError(result.message ?? 'Kod gönderilemedi. Lütfen tekrar deneyin.');
      }
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Bir hata oluştu. Lütfen tekrar deneyin.');
    } finally {
      setLoading(false);
    }
  };

  const handleModalConfirm = (): void => {
    setShowSuccessModal(false);
    navigate('/sifremi-unuttum/yeni-sifre', { state: { email: email.trim() } });
  };

  return (
    <>
      <AuthHeader />
      <div className="bg-light min-vh-100 d-flex align-items-center">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-6 col-lg-5">
              <div className="card shadow-sm">
                <div className="card-body p-4">
                  <h4 className="card-title text-center mb-4">
                    Şifremi Unuttum
                  </h4>
                  <div className="text-muted text-center mb-4">
                    E-posta adresinizi girin, şifrenizi sıfırlamanız için bir doğrulama kodu göndereceğiz.
                  </div>

                  {error && (
                    <div className="alert alert-danger mb-3" role="alert">
                      {error}
                    </div>
                  )}

                  <form onSubmit={handleSubmit}>
                    <div className="mb-4">
                      <label className="form-label" htmlFor="email">
                        E-posta
                      </label>
                      <input
                        className="form-control"
                        id="email"
                        name="email"
                        type="email"
                        required
                        placeholder="ornek@email.com"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                      />
                    </div>
                    <Button
                      className="btn btn-primary w-100 mb-3"
                      type="submit"
                      loading={loading}
                    >
                      Kod gönder
                    </Button>
                    <div className="text-center">
                      <Link className="text-decoration-none" to="/giris">
                        <i className="fas fa-arrow-left me-1" />
                        Giriş sayfasına dön
                      </Link>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {showSuccessModal && (
        <>
          <div
            className="modal fade show"
            style={{ display: 'block' }}
            tabIndex={-1}
            aria-modal="true"
            role="dialog"
          >
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content text-center p-4">
                <div className="modal-body py-4">
                  <div className="text-success mb-3">
                    <i className="fas fa-check-circle" style={{ fontSize: '4rem' }} />
                  </div>
                  <h5 className="mb-2">Kod Gönderildi</h5>
                  <p className="text-muted mb-0">
                    Şifre sıfırlama kodunuz e-posta adresinize gönderildi. Lütfen e-postanızı kontrol edin ve bir sonraki adımda kodu girin.
                  </p>
                </div>
                <div className="modal-footer border-0 justify-content-center pb-4">
                  <Button
                    type="button"
                    className="btn btn-primary"
                    onClick={handleModalConfirm}
                  >
                    Tamam
                  </Button>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-backdrop fade show" />
        </>
      )}
    </>
  );
};

export default SifremiUnuttum;
